<script lang="ts" setup>
import { propTypes } from '@/utils/propTypes'
import { Icon as IconifyIcon, iconLoaded } from '@iconify/vue'
import { useDesign } from '@/hooks/web/useDesign'

defineOptions({ name: 'Icon' })

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('icon')

const props = defineProps({
  // icon name
  icon: propTypes.string,
  // icon color
  color: propTypes.string,
  // icon size
  size: propTypes.number.def(16),
  // icon svg class
  svgClass: propTypes.string.def('')
})

const isLocal = computed(() => props.icon?.startsWith('svg-icon:'))

const symbolId = computed(() => {
  return unref(isLocal) ? `#icon-${props.icon.split('svg-icon:')[1]}` : props.icon
})

// 动态菜单可能传入未收录的图标；fa/fa-solid 已在 svgIcon 注册，勿强行替换。
// 注意：Element Plus 无 ep:question，只有 ep:question-filled。
const FALLBACK_ICON = 'ep:question-filled'
const resolvedIcon = computed(() => {
  const icon = String(symbolId.value || '').trim()
  if (!icon) return FALLBACK_ICON
  // 图片 URL / 本地路径不当作 Iconify 名
  if (/^(https?:)?\/\//i.test(icon) || icon.startsWith('/') || icon.startsWith('data:')) {
    return FALLBACK_ICON
  }
  if (iconLoaded(icon)) return icon
  // ep:xxx 去 filled 后若不存在，回退到 filled 原名
  if (icon.startsWith('ep:') && !icon.endsWith('-filled')) {
    const filled = `${icon}-filled`
    if (iconLoaded(filled)) return filled
  }
  return FALLBACK_ICON
})

const getSvgClass = computed(() => {
  const { svgClass } = props
  return `iconify ${svgClass}`
})
</script>

<template>
  <ElIcon :class="prefixCls" :color="color" :size="size">
    <svg v-if="isLocal" :class="getSvgClass">
      <use :xlink:href="symbolId" />
    </svg>

    <IconifyIcon
      v-else
      :icon="resolvedIcon"
      :class="getSvgClass"
      :style="{ fontSize: `${size}px`, color }"
    />
  </ElIcon>
</template>
